import { API_ENDPOINT } from './config.js';

async function apiHelper(action, method = 'GET', data = null, content = 'application/json') {

   	const url = `${API_ENDPOINT}/${action}`;
   	const token = localStorage.getItem('token');

    const body = content == 'application/json' ? JSON.stringify(data) : data
    let options = {
        method: method,
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json'
        }
    }

    if(data){
        let headers = {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        };

        if(content != 'application/json'){
          headers = {
            'Authorization': `Token ${token}`
          } 
        }
        options = {
          method: method,
          headers: headers,
          body : body,
        }
    }
   
    try {
       const response = await fetch(url, options);
       return response;
     } catch (error) {
       console.error('API Error:', error);
       //throw error;
     }
}

export default apiHelper;